var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcStats(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 40,
    viewBox: "0 0 47 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36_281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 0H4C1.79086 0 0 1.79086 0 4V28C0 30.2091 1.79086 32 4 32H36C38.2091 32 40 30.2091 40 28V4C40 1.79086 38.2091 0 36 0Z",
    fill: "#03F5AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 8H11C8.79086 8 7 9.79086 7 12V36C7 38.2091 8.79086 40 11 40H43C45.2091 40 47 38.2091 47 36V12C47 9.79086 45.2091 8 43 8Z",
    fill: "#AC6AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 8H40V28C40 29.0609 39.5786 30.0783 38.8284 30.8284C38.0783 31.5786 37.0609 32 36 32H7V12C7 10.9391 7.42143 9.92172 8.17157 9.17157C8.92172 8.42143 9.93913 8 11 8V8Z",
    fill: "#72F5FF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_36_281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.376 10.25H29.385C28.9028 10.2497 28.4313 10.3925 28.0303 10.6602C27.6292 10.928 27.3166 11.3087 27.132 11.7542C26.9475 12.1997 26.8992 12.6899 26.9934 13.1629C27.0875 13.6358 27.3199 14.0702 27.661 14.411L30.952 17.702L23.5 25.15L16.048 17.698C15.7462 17.3955 15.3877 17.1555 14.993 16.9918C14.5984 16.8281 14.1753 16.7438 13.748 16.7438C13.3207 16.7438 12.8976 16.8281 12.503 16.9918C12.1083 17.1555 11.7498 17.3955 11.448 17.698L4.476 24.679C4.32482 24.8299 4.20489 25.0092 4.12305 25.2065C4.04122 25.4038 3.9991 25.6154 3.9991 25.829C3.9991 26.0426 4.04122 26.2542 4.12305 26.4515C4.20489 26.6488 4.32482 26.8281 4.476 26.979L6.776 29.279C6.92693 29.4302 7.10619 29.5501 7.30352 29.632C7.50085 29.7138 7.71238 29.7559 7.926 29.7559C8.13963 29.7559 8.35116 29.7138 8.54849 29.632C8.74581 29.5501 8.92507 29.4302 9.076 29.279L13.754 24.6L21.2 32.05C21.5018 32.3525 21.8603 32.5925 22.255 32.7562C22.6496 32.9199 23.0727 33.0042 23.5 33.0042C23.9273 33.0042 24.3504 32.9199 24.745 32.7562C25.1397 32.5925 25.4982 32.3525 25.8 32.05L35.55 22.3L38.841 25.591C39.1822 25.9311 39.6166 26.1624 40.0892 26.2559C40.5618 26.3493 41.0515 26.3006 41.4965 26.1159C41.9415 25.9313 42.3218 25.6189 42.5893 25.2183C42.8569 24.8177 42.9998 24.3468 43 23.865V11.875C43.0003 11.6616 42.9584 11.4503 42.8769 11.2531C42.7954 11.0559 42.6758 10.8767 42.525 10.7257C42.3742 10.5748 42.195 10.4551 41.9979 10.3734C41.8007 10.2918 41.5894 10.2499 41.376 10.25V10.25Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_36_281",
    x: -4.0009,
    y: 2.25,
    width: 55.0009,
    height: 38.7543,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.370833 0 0 0 0 0.262035 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_36_281"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_36_281",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36_281"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 40,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStats);
export default __webpack_public_path__ + "static/media/ic_stats.52ed313e63f70af1fb4d75193d70e5a9.svg";
export { ForwardRef as ReactComponent };